import React from "react";

const SubTitle = ({ title }) => {
    return <h2 className="sub-title">{ title }</h2>
}

export default SubTitle;